import request from '@/utils/request'
import Vue from 'vue'

export const approvalMessageEvents = new Vue()
export const listApprovalMessages = params => request({ url: '/approvalMessage/list', method: 'get', params })
export const approvalMessageSummary = () => request({ url: '/approvalMessage/summary', method: 'get', silent: true })
export const getApprovalMessage = id => request({ url: `/approvalMessage/${encodeURIComponent(id)}`, method: 'get' })
export const readApprovalMessage = id => request({ url: `/approvalMessage/${encodeURIComponent(id)}/read`, method: 'post' })
export const commentParticipants = workOrderId => request({ url: '/workOrder/commentParticipants', method: 'get', params: { workOrderId } })
